<template id="render3dTmpl" >
  <div>
  <v-dialog v-model="dialogMapsListIsOpen" persistent max-width="500px">
    <v-card v-if="siteSelectedObj != null">
      <v-card-title>
        <span class="headline">{{siteSelectedObj.site_name}} - {{$t('lbl.mapsList')}}</span>
      </v-card-title>

      <v-card-text v-if="mapItems != null && mapItems.length > 0">
        <v-select v-model="mapSelectedId" :items="mapItems" :label="$t('lbl.selectMap')" @change='loadMapDetails'>
          <template slot="item"  slot-scope="data">
            <v-icon dark v-if="data.item.alert" class="alertIcon mr-2">mdi-alert</v-icon>{{ data.item.text }}
          </template>
        </v-select>
      </v-card-text>
      <v-card-text v-else class="font-weight-bold">
				{{$t('err.noMapsFound')}}
			</v-card-text>

      <v-card-actions>
        
        <v-row no-gutters>
          <v-col cols="12" md="4" class="pa-1" v-if="mapDetailObj != null">
             <v-btn class="button-main" style="width: 100%" v-on:click="gotoMapDetails()" ><v-icon left dark>zoom_in</v-icon>{{$t('btn.details')}}</v-btn>
          </v-col>
          <v-col cols="12" md="4" class="pa-1" v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && (mapDetailObj.map_asset_type == 'render3d_pro' ||  mapDetailObj.map_asset_type == 'render3d_basic')">
            <v-btn class="button-main" style="width: 100%" v-on:click="gotoMapRenderShin()"><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderShin')}}</v-btn>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-btn class="button-main" style="width: 100%" v-on:click="closeDialogMapList()" ><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
          </v-col>
        </v-row>
        
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-card-title>
        {{$t('err.siteSelectedNotValid')}}
      </v-card-title>

      <v-card-actions>
          <v-btn  class="button-main" v-on:click="closeDialogMapList()" ><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
 
  <!-- DIALOG RENDERING 3D-->
	<ct-map-dlg-render-shin ref="renderShin"></ct-map-dlg-render-shin>

  </div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctDialogRenderShin from "@/components/commons/ctDialogRenderShin.vue";

export default {
    i18n,
    data: () => ({
      orgid:null,
      siteSelectedObj: null,
      dialogMapsListIsOpen: false,
      mapsList: [],
      mapItems: [],
      mapSelectedId: null,
      mapDetailObj: null,
    }),
    components: {
      'ct-map-dlg-render-shin': ctDialogRenderShin,
    },
    methods: {
      openDialogMapList(orgid, siteObj) 
      {
        this.orgid = orgid;
        this.siteSelectedObj = siteObj;
        this.loadMapList();
       
      },
      closeDialogMapList() 
      {
        this.siteSelectedObj = null;
        this.mapsList = [];
        this.mapItems = [];
        this.mapSelectedId = null;
        this.mapDetailObj = null;
        this.dialogMapsListIsOpen = false;
      },
      loadMapList()
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if (this.isEmptyObj(this.siteSelectedObj)) 
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        } 
        else
        {
          this.mapsList = [];
          //var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.orgid  + '/sites/' + this.siteSelectedObj.site_id +'/maps';
          var endpoint2go = constants.ENDPOINT_GATEWAY_MAPS_LIST_ALERT;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteSelectedObj.site_id;

          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadMapList);
         
         } 
      },
      callbackLoadMapList(responseData) 
      {
        if(!this.isEmptyObj(responseData))
        {
          
          this.mapsList = this.getSecureMapList(responseData, true);

          this.populateMapItems();
          this.dialogMapsListIsOpen = true;
        }
      },
      populateMapItems() 
      {
        this.mapItems = [];
        for (var i = 0; i < this.mapsList.length; i++) {
          try {
            var mapObj = this.mapsList[i];
            this.mapItems.push({
              text: mapObj.map_name,
              value: mapObj.sitemap_id,
              alert: mapObj.alert
            });
          } catch (err) {
            console.log(err);
          }
        }
      },
      gotoMapRenderShin() 
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if (this.isEmptyObj(this.siteSelectedObj)) 
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        } 
        else if (this.isEmptyObj(this.mapDetailObj)) 
        {
          this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
        } 
        else 
        {
          // CHIUDO IL RENDERING 3D
          this.$refs.renderShin.closeMapRenderShin();

          // APRO IL RENDERING 3D
          this.$refs.renderShin.openMapRenderShin(this.orgid, this.siteSelectedObj.site_id, this.mapDetailObj);
        }
      },
      gotoMapDetails()
      {
          if(this.isEmptyString(this.orgid))  
          {
            this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
          }
          else if(this.isEmptyObj(this.siteSelectedObj)) 
          {
            this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
          } 
          else if(this.isEmptyString(this.mapSelectedId)) 
          {
            this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
          } 
          else 
          {
            var url2go = '/appgui/map/' + this.orgid + '/' + this.siteSelectedObj.site_id + '/' + this.mapSelectedId;
            this.$root.goToPage(url2go);
          }
      },
      loadMapDetails() 
      {
          if(this.isEmptyString(this.orgid))  
          {
            this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
          }
          else if(this.isEmptyObj(this.siteSelectedObj)) 
          {
            this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
          } 
          else if(this.isEmptyString(this.mapSelectedId)) 
          {
            this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
          } 
          else 
          {
            var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.orgid  + '/sites/' + this.siteSelectedObj.site_id +'/maps/' + this.mapSelectedId;
            this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadMapDetails);
          }
      },
      callbackLoadMapDetails(responseData) 
      {
        this.mapDetailObj = responseData;
      }
    }
};
</script>